import LinearProgress from '@/components/LinearProgress'
import TrainingListItem from '@/components/TrainingListItem'
import Spinner from '@/shared/Spinner'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'

const mapStateToProps = ({ session, loading }) => ({
  ...session,
  isLoading: loading['session/getSessionSummary'],
  isUpdatingCourse: loading['session/updateCourseWatch'],
})

const TrainingSession = ({ dispatch, isLoading, summary, courseList, isUpdatingCourse }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { sessionToken } = useParams()

  const {
    campaignEndDate,
    campaignName,
    totalCount,
    pendingCount,
    completedCount,
    progress = 0,
    userName,
  } = summary || {}

  useEffect(() => {
    if (sessionToken && !isUpdatingCourse) {
      dispatch({ type: 'session/getSessionSummary', payload: { sessionToken } })
    }
  }, [sessionToken, isUpdatingCourse, dispatch])

  return (
    <Container spacing={3}>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} md={8}>
          <Stack height="100%" justifyContent="center">
            {!isLoading ? (
              <Box>
                <Typography textAlign="center" variant="h5">
                  {campaignName}
                </Typography>
                <Typography textAlign="center" variant="h5" sx={{ mt: 2 }}>
                  {t('course.intro', { name: userName })}
                </Typography>
              </Box>
            ) : (
              <Spinner />
            )}
          </Stack>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ minHeight: 170, display: 'flex' }}>
            {!isLoading ? (
              <CardContent sx={{ width: '100%' }}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{ fontWeight: 'bold', color: theme => theme.palette.secondary[30].main }}
                    >
                      {t('general.course_status')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>{`${t('general.course_complete_duration')} : ${moment(
                      campaignEndDate,
                    ).format('YYYY/MM/DD')}`}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>{`${t(
                      'general.course_mandatory_count',
                    )} : ${totalCount}`}</Typography>
                  </Grid>
                  <Grid item container spacing={2} xs={12}>
                    <Grid item>
                      <Typography>{`${t('general.completed')} : ${completedCount}`}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography>{`${t('general.incomplete')} : ${pendingCount}`}</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center">
                      <Typography>{`${t('general.progress')} : ${progress}%`}</Typography>
                      <LinearProgress sx={{ ml: 2, flex: 1 }} value={progress} />
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            ) : (
              <Spinner />
            )}
          </Card>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography textAlign={'center'}>{t('general.course')}</Typography>
              <List>
                {courseList.map(course => {
                  const { courseRecordDetailId } = course

                  return (
                    <TrainingListItem
                      key={courseRecordDetailId}
                      data={course}
                      onClick={() => {
                        navigate(`/training_session/${sessionToken}/course/${courseRecordDetailId}`)
                      }}
                    />
                  )
                })}
              </List>

              {isLoading && <Spinner />}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  )
}

export default connect(mapStateToProps)(TrainingSession)
